import { useEffect } from 'react';

// labels on the map never cover each other: lower-priority labels slide down until they are free (screen space only)
// report pins are fixed obstacles; the visible box is the label itself (wrappers are 0×0 or offset by CSS)
const FIXED = '.pin-wrap:not(.pp-wrap)';
const SEL = ['.pp-wrap', '.dry-tag-wrap', '.pit-label', '.cable-badge-wrap', '.priv-len-tip', '.svy-mk-wrap'];
const hit = (a, b) => a.left < b.right && a.right > b.left && a.top < b.bottom && a.bottom > b.top;
const boxOf = (e) => {
  const kids = [...e.querySelectorAll('*')].filter((k) => k.getBoundingClientRect().width > 0);
  const rs = (kids.length ? kids : [e]).map((k) => k.getBoundingClientRect()).filter((r) => r.width > 0);
  if (!rs.length) return null;
  return { left: Math.min(...rs.map((r) => r.left)), right: Math.max(...rs.map((r) => r.right)), top: Math.min(...rs.map((r) => r.top)), bottom: Math.max(...rs.map((r) => r.bottom)) };
};

export function declutter(root) {
  if (!root) return;
  const els = SEL.flatMap((s) => [...root.querySelectorAll(s)]);
  els.forEach((e) => { e.style.translate = ''; });
  const placed = [...root.querySelectorAll(FIXED)].filter((e) => e.querySelector('.rep-pin')).map(boxOf).filter(Boolean);
  els.forEach((e) => {
    const r0 = boxOf(e);
    if (!r0) return;
    let dy = 0, r = r0;
    for (let i = 0; i < 12; i += 1) {
      const o = placed.find((p) => hit(r, p));
      if (!o) break;
      dy += o.bottom - r.top + 4;
      r = { left: r0.left, right: r0.right, top: r0.top + dy, bottom: r0.bottom + dy };
    }
    if (dy) e.style.translate = `0 ${Math.round(dy)}px`;
    placed.push(r);
  });
}

export default function useDeclutter(mapRef, deps) {
  useEffect(() => {
    const map = mapRef.current;
    if (!map) return undefined;
    let tm = null;
    const run = () => { clearTimeout(tm); tm = setTimeout(() => declutter(map.getContainer()), 150); };
    map.on('zoomend moveend layeradd', run);
    run();
    return () => { clearTimeout(tm); map.off('zoomend moveend layeradd', run); };
  }, deps); // eslint-disable-line react-hooks/exhaustive-deps
}
